/**
 * Per-service commission rates feature flag. The "Use different rates for
 * specific services" section of the commission form (staff + tier templates),
 * the Rates-tab "+N custom" badge and the Staff Earnings "Commission by
 * service" drill-down ship behind this wall. Default OFF.
 *
 * Mirrors `isGiftCardsEnabled` (utils/giftCardsFlag.ts). Read at call time so
 * tests can flip `process.env.REACT_APP_SERVICE_COMMISSION_OVERRIDES_ENABLED`
 * per case.
 */
export function isServiceCommissionOverridesEnabled(): boolean {
  return process.env.REACT_APP_SERVICE_COMMISSION_OVERRIDES_ENABLED === "true";
}
